"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STORE_PARAM = exports.SHARE_OPEN_PARAM = exports.COOKIE_NAME = void 0;
/**
 * Name of query param, if true the dialog will be opened automatically.
 */
const SHARE_OPEN_PARAM = exports.SHARE_OPEN_PARAM = 'share';
/**
 * Name of cookie that that contains the store id.
 */
const COOKIE_NAME = exports.COOKIE_NAME = 'pbs_owner';
/**
 * Name of query param that contains the store id.
 */
const STORE_PARAM = exports.STORE_PARAM = 'store';
